// extracted by mini-css-extract-plugin
export var actionIcon = "_sd-0";